/**
 * @vuelto-surface
 * mobile: ok
 * desktop: ok
 * strategy: unified
 */
import React from 'react';
import { Ionicons } from '@expo/vector-icons';
import { StyleSheet, Text, TouchableOpacity, View } from 'react-native';
import { typography } from '../../shared/theme/typography';
import { ticketColors } from '../../shared/theme/ticketColors';
import { WEB_BUTTON_FOCUS_RESET } from '../../shared/ui/webButtonFocusReset';

type Props = {
  count: number;
  onPress: () => void;
};

/** Móvil: aviso compacto antes del listado; abre el modal de pendientes. */
export function InventoryPendingTransfersBanner({ count, onPress }: Props) {
  if (count <= 0) return null;

  const label =
    count === 1
      ? '1 transferencia para recibir'
      : `${count} transferencias para recibir`;

  return (
    <TouchableOpacity
      style={[styles.banner, WEB_BUTTON_FOCUS_RESET]}
      onPress={onPress}
      activeOpacity={0.85}
      accessibilityRole="button"
      accessibilityLabel={label}
    >
      <Ionicons name="swap-horizontal-outline" size={20} color={ticketColors.gold} style={styles.icon} />
      <View style={styles.textWrap}>
        <Text style={styles.title} numberOfLines={2}>
          {label}
        </Text>
        <Text style={styles.subtitle}>Recibí o rechazá desde acá</Text>
      </View>
      <Ionicons name="chevron-forward" size={18} color={ticketColors.ink3} />
    </TouchableOpacity>
  );
}

const styles = StyleSheet.create({
  banner: {
    marginBottom: 14,
    flexDirection: 'row',
    alignItems: 'center',
    gap: 10,
    paddingVertical: 12,
    paddingHorizontal: 14,
    borderRadius: 14,
    borderWidth: 1,
    borderColor: 'rgba(250, 204, 21, 0.42)',
    backgroundColor: 'rgba(250, 204, 21, 0.08)',
    alignSelf: 'stretch',
  },
  icon: {
    flexShrink: 0,
  },
  textWrap: {
    flex: 1,
    minWidth: 0,
    gap: 2,
  },
  title: {
    ...typography.caption,
    color: ticketColors.ink,
    fontWeight: '800',
  },
  subtitle: {
    ...typography.caption,
    fontSize: 11,
    color: ticketColors.ink3,
    fontWeight: '600',
  },
});
